<template>
  <button
    type="submit"
    class="w-full aha-button aha-button-primary aha-button-xl"
    @click.prevent="handleGoogleSignin"
  >
    <span
      class="icon"
    >
      <aha-icon
        maintain-color
        name="gg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      />
    </span>
    <slot />
    <aha-spinner class="ml-2" variant="white" v-if="submittingGG" />
  </button>
</template>

<script>
import { mapActions } from 'vuex'
import constant from '@/constant'
import Util from '@/util'
import config from '@/config'
import { isTrialLink } from '@/utils/trial-plan.utils'

const isAuthFormVersion2 = true

export default {
  name: 'GoogleButtonV2',
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  data: () => {
    return {
      submittingGG: false,
    }
  },
  methods: {
    ...mapActions([
      'setIsServerConnectableAction',
    ]),
    handleGoogleSignin() {
      this.submittingGG = true
      Util.mixpanelTracking(
        'Register',
        `Click ${this.type} button`,
        'with google',
        null,
        {
          isAuthFormVersion2,
        },
      )

      const {
        GOOGLE_SIGNIN_FROM,
        GOOGLE_SIGNIN_SOURCE,
        GOOGLE_SIGNIN_REDIRECT,
        GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL,
        GOOGLE_SIGNIN_SAVE_WORDCLOUD,
      } = constant.storageKeys
      window.localStorage.setItem(GOOGLE_SIGNIN_FROM, this.type)
      window.localStorage.setItem(GOOGLE_SIGNIN_SOURCE, window.location.href)
      window.localStorage.setItem('isTrialLink', isTrialLink(window.location.href))
      const redirect = Util.getParamValue('redirect', window.location.href)
      const spinnerwheel = Util.getParamValue('spinnerwheel', window.location.href)
      const wordcloud = Util.getParamValue('wordcloud', window.location.href)
      if (redirect) {
        window.localStorage.setItem(GOOGLE_SIGNIN_REDIRECT, redirect)
      }
      if (spinnerwheel) {
        window.localStorage.setItem(GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL, wordcloud)
      }
      if (wordcloud) {
        window.localStorage.setItem(GOOGLE_SIGNIN_SAVE_WORDCLOUD, wordcloud)
      }

      setTimeout(() => {
        this.submittingGG = false
        this.$func.go(config.api.googleSignin)
      }, 1000) // give timeout to avoid cancel gaTracking
    },
  },
}
</script>

<style lang="scss" scoped>
button.aha-button {
  --tw-shadow: none !important;
  --tw-shadow: none !important;
  --tw-translate-y: 0 !important;

  &:hover {
    @apply bg-primary-100;
  }

  height: 3.5rem;

  .icon {
    position: absolute;
    left: 0.25rem;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
